import { render } from "./sppBilling.vue?vue&type=template&id=282f24c6&scoped=true"
import script from "./sppBilling.vue?vue&type=script&lang=js"
export * from "./sppBilling.vue?vue&type=script&lang=js"

import "./sppBilling.vue?vue&type=style&index=0&id=282f24c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282f24c6"]])

export default __exports__